export enum CropWorkType {
  SOIL_TREATMENT = 'soil_treatment',
  SOWING_OR_PLANTING = 'sowing_or_planting',
  DISPERSION_OR_SPRAYING = 'dispersion_or_spraying',
  MOWING = 'mowing',
  THRESHING = 'threshing',
  FORAGE_HARVESTING = 'forage_harvesting',
  FRUIT_HARVESTING = 'fruit_harvesting',
  VEGETABLE_ETC_HARVESTING = 'vegetable_etc_harvesting',
  OTHER = 'other',
}
